import { SharedOfficeRequest, SharedOfficeResponse } from './../types/SharedOffice'
import http from '../core/http-common'
import {
  IAuthFloorListByLocation,
  IFloorFilteredDeskListRequest,
  IFloorList,
  IFloorProperties,
  IFloorTemplate,
  ISearchFloor,
  Occupancy,
  OccupancyFilterRequest,
} from '../types/FloorType'
import { IFloorMessage } from '../types/FloorMessageType'
import { IDesk } from '../types/DeskType'

class FloorService {
  getFloorTemplate(floorId: number) {
    return http.get<IFloorTemplate>(`/Floor/GetFloorTemplate?floorId=${floorId}`)
  }

  /* searchFloor(query: string, date: string, myFirm: boolean) {
         let url = `/Floor/SearchFloor?searchText=${query}`;
         if (date !== undefined)
             url += `&occupancyDate=${date}`;
         if (myFirm !== undefined)
             url += `&myFirm=${myFirm}`;
         return http.get<IFloorList[]>(url)
     }*/

  GetAuthFloorList(blockId: number, occupancyDate: string, myFirm: boolean) {
    return http.get<IFloorList[]>(
      `/Floor/GetAuthFloorList?blockId=${blockId}&occupancyDate=${occupancyDate}&myFirm=${myFirm}`
    )
  }

  GetFloorOccupancy(request: OccupancyFilterRequest) {
    return http.post<any>('/Floor/GetFloorOccupancy', request)
  }

  searchFloor(request: ISearchFloor) {
    return http.post<IFloorList[]>('/Floor/SearchFloor', request)
  }

  getAuthAllProperties(floorId: number) {
    return http.get<IFloorProperties[]>('/Floor/GetAuthAllProperties?floorId=' + floorId)
  }

  getTablePropertiesByFloorId(floorId: number) {
    return http.get<IFloorProperties[]>('/Table/GetTablePropertiesByFloorId?floorId=' + floorId)
  }

  getFilteredDeskList(request: IFloorFilteredDeskListRequest) {
    return http.post<IDesk[]>('/Desk/GetFilteredDeskList', request)
  }

  getMyDedicatedFloor(occupancyDate: string) {
    return http.get<IFloorList>('Floor/GetMyDedicatedFloor?occupancyDate=' + occupancyDate)
  }
  getFloorMessageById(floorId: number) {
    return http.get<IFloorMessage>('FloorMessage/GetFloorMessage?floorId=' + floorId)
  }
  getFloorCalendarDaysAvailable(request: SharedOfficeRequest) {
    return http.post<SharedOfficeResponse>('/Floor/FloorCalendarDaysAvailable', request)
  }

  /* Map - Floor Sidebar */
  getLocationsFloorListByLocation(locationId: number) {
    return http.get<IAuthFloorListByLocation[]>(`/Floor/GetAuthFloorListByLocation?locationId=${locationId}`)
  }

  getLocationFloorsOccupancy(request: OccupancyFilterRequest) {
    return http.post<Occupancy[]>('/Floor/GetAuthFloorOccupancyListByLocation', request)
  }
}

export default new FloorService()
